import { api } from "constants/RotasAPI";
import { LoadingContext } from "context/LoadingContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { downloadFile } from "shared/util/functions/download/DownloadFunctions";
import { http } from "shared/util/http";
import { RequestFiltroRelatorio } from "types/request/RequestFiltroRelatorio";

const useGetEmitirRelatorioAcordoDetalhado = () => {
  const { setLoading } = useContext(LoadingContext);

  const emitirRelatorioAcordoDetalhado = async (request: RequestFiltroRelatorio) => {
    setLoading(true);
    await http
      .get(api.relatorios.emitirRelatorioAcordoDetalhado, request)
      .then((response) => {
        toast.success("Relatório emitido com sucesso");
        downloadFile(
          response.data,
          `Acordo nº ${request.numeroAcordo} detalhado`,
          "application/pdf",
          false
        );
      })
      .catch((error) => {
        toast.error("Erro ao gerar relatório de acordo detalhado");
      })
      .finally(() => setLoading(false));
  };

  return { emitirRelatorioAcordoDetalhado };
};

export default useGetEmitirRelatorioAcordoDetalhado;
